<template>
    <div class="health-inspection-container">
        <div class="question">
            <h1 class="main-title">问题历史记录</h1>
            <div class="section">
                <ul class="question-list" ref="questionList">
                    <li class="question-item" v-for="(item, index) in List" :key="item.id" :class="isindex == index ? 'active' : ''" @click="setIndex(index, item)" ref="questionItem">
                        <span class="question-text">{{ item.question }}</span>
                        <button class="close-button" @click.stop="removeItem(index,item)">×</button>
                    </li>
                </ul>
            </div>
        </div>
        <div class="box">
        <div class="answers">
            <div class="answer-section">
                <el-scrollbar style="height: 100%;">
                    <div class="answer-item" v-for="(item,index) in askLists" :key="index">
                        <h3 class="wenti"><span>{{item.content}}</span></h3>
                        <p class="answer" v-loading="index == askLists.length -1 && loading ? 'loading':''" v-html="formattedStr(item.daan)" style="min-height:20px;"></p>
                        <el-divider></el-divider>
                    </div>
                </el-scrollbar>
            </div>
            
            <div class="search-section">
                <div class="search-top">
                    <div class="newAsk" @click="getNewAsk">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.856 17.121a.979.979 0 0 1-.327-.06.839.839 0 0 1-.283-.177.739.739 0 0 1-.187-.255.724.724 0 0 1-.07-.303l-.02-1.609a4.663 4.663 0 0 1-1.446-.455 4.252 4.252 0 0 1-.637-.401c-.199-.146-.385-.31-.553-.492a4.442 4.442 0 0 1-.45-.577 4.303 4.303 0 0 1-.327-.637 3.823 3.823 0 0 1-.206-.686 3.729 3.729 0 0 1-.064-.704V6.478c0-.261.025-.516.077-.771a4.43 4.43 0 0 1 .244-.747 4.062 4.062 0 0 1 .932-1.28c.2-.183.418-.347.65-.493.23-.145.482-.267.739-.364a4.21 4.21 0 0 1 .81-.225c.27-.054.553-.078.835-.078H8.55c.103 0 .2.018.29.054a.7.7 0 0 1 .411.376.667.667 0 0 1-.161.766.736.736 0 0 1-.25.151.764.764 0 0 1-.29.055H5.573c-.186 0-.366.012-.54.049-.18.03-.353.079-.52.145-.167.061-.328.14-.482.237-.148.091-.29.2-.418.316a2.897 2.897 0 0 0-.347.388c-.097.14-.187.286-.257.444a2.473 2.473 0 0 0-.206.977v4.287c0 .17.013.333.051.503a2.549 2.549 0 0 0 .772 1.33 2.721 2.721 0 0 0 .913.559c.167.066.347.115.527.152.18.03.36.048.546.048a.904.904 0 0 1 .61.23.848.848 0 0 1 .194.262.84.84 0 0 1 .07.303l.007.99 1.915-1.293a2.877 2.877 0 0 1 1.64-.492h2.372c.186 0 .366-.018.54-.048.18-.03.353-.08.52-.146.168-.067.329-.146.483-.237.148-.091.29-.2.418-.316.128-.121.244-.249.347-.388a2.8 2.8 0 0 0 .257-.444 2.47 2.47 0 0 0 .206-.977V8.585a.646.646 0 0 1 .225-.492.679.679 0 0 1 .244-.152.814.814 0 0 1 .585 0c.09.03.174.085.244.152a.657.657 0 0 1 .225.492V10.8c0 .261-.032.516-.083.771a4.192 4.192 0 0 1-.245.74c-.109.244-.244.468-.398.687a3.735 3.735 0 0 1-.534.6c-.2.183-.418.347-.65.493a4.134 4.134 0 0 1-.738.364 4.7 4.7 0 0 1-.81.225c-.27.054-.553.079-.836.079h-1.877c-.604 0-1.144.164-1.633.491l-2.54 1.713a.913.913 0 0 1-.514.157z" fill="currentColor"></path><path d="M15.866 4.125h-4.174c-.41 0-.741.313-.741.7 0 .387.332.7.741.7h4.174c.41 0 .742-.313.742-.7 0-.387-.332-.7-.742-.7z" fill="currentColor"></path><path d="M14.537 2.932c0-.396-.34-.717-.759-.717s-.758.32-.758.717v3.786c0 .396.34.717.758.717.42 0 .76-.321.76-.717V2.932z" fill="currentColor"></path>
                        </svg>
                        <span>开启新对话</span>
                    </div>
                </div>
                <div class="follow-button">
                    <el-input placeholder="发送你的问题" type="textarea" rows="3" :autosize="{ minRows: 3, maxRows: 10 }" v-model="search" :disabled="loading" />
                    <img src="../../../assets/images/tijiao.png" @click="submit" />
                </div>
                <div class="search-title">
                    <el-select v-model="xuanze1" size="small" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-select v-model="xuanze2" size="small" placeholder="请选择">
                        <el-option label="通义千问" value="通义千问"></el-option>
                        <el-option label="DeepSeek-R1" value="DeepSeek-R1"></el-option>
                        <el-option label="DeepSeek-V3" value="DeepSeek-V3"></el-option>
                        
                    </el-select>
                </div>
            </div>
        </div>
        </div>
        <div class="zhinengku">
            <h3>智能库</h3>
            <ul class="znUl">
                <li v-for="(item,index) in znList">
                    <p>
                        <span>{{item.name}}</span>
                        <el-switch v-model="item.isopen" :disabled="xuanze2 != '通义千问'" active-value="1" inactive-value="0"></el-switch>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    watch:{
    },
    data() {
        return {
            loading:false,
            isindex:-1,
            List:[],
            askLists:[],
            options:[],
            search:'',
            xuanze1:'',
            xuanze2:'通义千问',
            sessionId:'',
            closeButtonVisibleIndex: -1, // 用于控制关闭按钮的显示
            dm:'',
            cmid:'',
            znList:[],
            baseUrl:''
        };
    },

    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl
        axios({
            method: 'get',
            url: this.baseUrl+`/api/selectTree`,
            params: {
                cmid: this.cmid,
            },
            headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        }).then(res => {

            if(res.data && res.data.data){
                this.options = res.data.data
                this.xuanze1 = res.data.data[0].id
            }
        })

        axios({
            method: 'get',
            url: this.baseUrl+`/api/aiIntelligentLibrary`,
            params: {
            },
            headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
        }).then(res => {
            if(res.data && res.data.data){
                this.znList = res.data.data
            }
        })
        this.getList()
    },
    methods: {
        setIndex(index,item){
            this.askLists = []
            this.isindex = index;
            this.getAskList(item)
        },
        getList(){
            this.List = []
            
            axios({
                method: 'get',
                url: this.baseUrl+`/api/historyAns`,
                params: {
                    userId: this.dm,
                }
            }).then(res => {
                this.List = res.data.data
            })
        },
        getAskList(item){
            this.znList.forEach(item2 => {
                item2.isopen = '0'
            })
            this.sessionId = item.sessionId
            axios({
                method: 'get',
                url: this.baseUrl+`/api/history`,
                params: {
                    sessionId: item.sessionId,
                }
            }).then(res => {
                console.log(res.data,999)
                let arr = res.data.data
                let str = ''
                arr.forEach(item => {
                    item.daan = item.questionList[0].content ? item.questionList[0].content : ''
                    this.askLists.push(item)
                    if(item.aiTypeId){
                        str += (str ? ',' : '') + item.aiTypeId; // 累加 aiTypeId，避免开头的逗号
                        console.log(str, 999)
                    }
                })
                this.znList.forEach(item2 => {
                    if(str.indexOf(item2.id) != -1){
                        item2.isopen = '1'
                    }else{
                        item2.isopen = '0'
                    }
                })
            })
        },
        formattedStr(str) {
            if (typeof str !== 'string') {
                console.warn('formattedStr received non-string input:', str);
                return '';
            }
            return str
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                .replace(/\n/g, '<br>')
                .replace(/^ - /gm, '&nbsp;&nbsp;- ');
        },
        submit(){
            this.isindex = -1
            let date = 'test-session-' + new Date().getTime()
            let wenti = this.search
            this.askLists.push({content:wenti})
            this.loading = true;
            this.search = ''
            let znStr = ''
            this.znList.forEach(item => {
                if (item.isopen == 1) {
                    znStr += (',' + item.id)
                }
            })
            if (znStr.startsWith(',')) {
                znStr = znStr.slice(1)
            }
            console.log(znStr, 111)
            axios({
                method: 'post',
                url: this.baseUrl+`/api/ask`,
                data: {
                    sessionId: this.sessionId ? this.sessionId : date,
                    question: wenti,
                    userId:this.dm,
                    typeAsk:this.xuanze1,
                    typeTool:this.xuanze2,
                    aiTypeId:znStr,
                    cmid:this.cmid,
                },
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
            }).then(res => {
                this.loading = false;
                if(res.data){
                    console.log(res.data,122)
                    let mm = this.askLists.length
                    this.askLists[mm - 1].daan = res.data.data.question
                    this.sessionId = res.data.data.sessionId
                    this.getList()
                    this.$nextTick(() => {
                        this.scrollToLastQuestion()
                    })
                }else{
                    this.$message({
                        message: res.data.msg || '请求失败',
                        type: 'error'
                    });
                }
            }).catch(error => {
                this.loading = false;
                this.$message({
                    message: error,
                    type: 'error'
                });
            });
        },
        getNewAsk(){
            this.askLists = []
            this.isindex = -1
            this.sessionId = ''
        },
        isCloseButtonVisible(index) {
            return this.closeButtonVisibleIndex === index;
        },
        removeItem(index,item) {
            this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/api/remove`,
                    data: {
                        sessionId: item.sessionId,
                        userId: this.dm,
                    },
                    headers: { // 添加请求头
                        "Content-Type": "application/json" // 明确声明为 JSON 格式
                    },
                }).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    if(this.askLists[0].sessionId == this.sessionId){
                        this.askLists = []
                    }
                    this.getList()  
                }).catch(err => {
                    this.$message({
                        message: '删除失败',
                        type: 'error'
                    });
                })	
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });	
        },
        scrollToLastQuestion() {
            const ul = this.$refs.questionList;
            if(ul && ul.lastElementChild){
                const lastLi = ul.lastElementChild;
                lastLi.lastElementChild.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
}
</script>


<style scoped>
.health-inspection-container {
  font-family: Arial, sans-serif;
  width: 100%;
  height:calc(100vh - 200px);
  margin: 0 auto;
  color: #333;
  overflow:hidden;
  display:flex;
  justify-content:space-between;
}
.question{
    width: 20%;
    background:#fff;
    height:calc(100% - 70px);
    padding:35px 20px 35px 20px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
border-radius: 6px;
}
.box{
    width:calc(60% - 6px);
    margin:0 3px;
    display: flex;
    justify-content: center;
}
.answers{
    width: 80%;
    height:calc(100% - 20px);
    padding:10px 20px;
    position:relative;
}
.zhinengku{
    width: 20%;
    background:#fff;
    height:calc(100% - 70px);
    padding:35px 20px 35px 20px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
border-radius: 6px;
}
.main-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-left: 25px;
  background:url(../../../assets/images/ask.png) no-repeat center left;
  background-size: 20px 20px;
}

.question-list {
  list-style-type: none;
  padding-left: 20px;
}

.question-item {
  display: block;
  font-size: 14px;  
  padding-left: 15px;
  margin-bottom: 8px;
  border-radius: 10px;
  cursor:pointer;
}

.question-item.active {
  background:#e8f3fd;
  color: #000;
}

.question-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  width: calc(100% - 20px);
  display: inline-block;
  line-height: 40px;
}

.close-button {
  background: none;
  border: none;
  color: #ff4d4f;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
  display: none;
      float: right;
    line-height: 40px;
}
.question-item:hover{
    background:#eee;
}

.question-item:hover .close-button {
  display: block;
}

.divider {
  border-top: 1px solid #ddd;
  margin: 20px 0;
}

.answer-section {
  padding-bottom: 30px;
    height: calc(100% - 150px);
}
.answer-section >>> .el-scrollbar { width: 100%; height: 100%;}
.answer-section >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.answer-section >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.answer-section >>> .el-scrollbar__view{min-height: 100%;}

.wenti{
    width: auto;
    text-align:right;
    font-weight:normal;
    margin:10px 0;
    
}
.wenti span{
    background:#c3e1fc;
    font-size:14px;
    color: #000;
    padding: 7px 18px;
    line-height: 26px;
    border-radius: 10px;
    display: inline-block;
}
.answer-item {
  margin-bottom: 20px;
}

.answer {
  font-size: 14px;
  line-height: 1.5;
  padding-left: 20px;
  white-space: pre-wrap; /* 保留空白符，兼容原生换行 */
}

.search-section {
  margin-top: 30px;
  position: absolute;
  bottom: 10px;
  width: calc(100% - 42px);
}

.search-title {
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
  overflow: hidden;
}
.search-title .el-select{
    margin-right:10px;
}
.search-title >>> .el-select .el-input__inner{
    background:#dfdfdf;
    border-color: #dfdfdf;
    border-radius: 10px;
    color: #000;
}
.search-top{ width:100%; display:flex; margin-bottom:10px;justify-content: center;}
.newAsk {
    white-space: nowrap;
    background-color: #dbeafe;
    color: #4d6bfe;
    cursor: pointer;
    z-index: 1;
    border-radius: 12px;
    align-items: center;
    gap: 10px;
    width: fit-content;
    padding: 2px 14px;
    font-size: 14px;
    line-height: 28px;
    display: flex;
}
.newAsk:hover {
    background-color: #c3daf8;
}
.newAsk >>> svg{
    width: 18;
    height: 18;
    fill: none;
}
.follow-button {
  background-color: #f5f5f5;
  border:solid 1px #ccc;
  border-radius: 10px;
  width:100%;
  display:block;
  overflow:hidden;
  position:relative;
}

.follow-button .el-textarea {
    float:left;
    width: calc(100% - 80px);
    background:#f5f5f5;
    border:none;
    outline:none;
    max-height: calc(12* var(--ds-line-height-l));
}
.follow-button >>> .el-textarea__inner{
    border:none !important;
    outline:none !important;
    background:#f5f5f5;
}
.follow-button img{
    position:absolute;
    top:50%;
    right:15px;
    margin-top:-25px;
    float:right;
    width: 50px;
  height: 50px;
  cursor:pointer;
}

.answer-section >>> .el-loading-mask{
    background:#f2f5f6;
}

.znUl{padding-top:10px;}
.znUl li{width: 100%;height: 60px;background: #FFFFFF;border-radius: 4px;border: 1px solid #E6E6E6; margin:10px 0;}
.znUl li p{ width:100%; overflow:hidden;}
.znUl li span{ font-size:14px; line-height:60px; float:left; margin-left:12px;width: calc(100% - 74px);white-space: nowrap; text-overflow: ellipsis; overflow: hidden;}
.znUl li .el-switch{ float:right; margin:20px 12px 0 10px;}
</style>